<template>
  <div class="formmessage formmessage-success w-form-done">
    <slot />
  </div>
</template>

<script>
  export default {
    name: 'SuccessMessage',
  };
</script>

<style scoped>
  .formmessage {
    display: block;
  }
  .formmessage.formmessage-success {
    border-radius: 4px;
    background-color: rgba(0, 202, 125, 0.16);
    color: #1b2d3f;
  }
</style>
